import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { cfpBaseUrl } from '../../network/urls';
import { resolveApiOfficeCode } from '../../utils/adminCompany';


const initialState = {
    data: [],
    currentPage: 1,
    pageSize: 20,
    dateFrom: '',
    dateTo: '',
    applicationProgressId: '',
    objectionStatus: '',
    totalPages: null,
    totalRecords: null,
    isLoading: false,
    error: null,
}

// Define an async thunk for fetching paginated data
export const fetchPaginatedDueDateExtensionNormal = createAsyncThunk(
    'generalServices/fetchDueDateExtensionNormal',
    async ({ page, pageSize, dateFrom, dateTo, applicationProgressId, objectionStatus, officeCode }, { getState }) => {
        const { auth } = getState();
        const { token, code, hierarchy, showAllApplicationsFlag, roleId, selectedAdminCompanyCode } = auth;
        const effectiveOfficeCode = resolveApiOfficeCode(code, roleId, officeCode, selectedAdminCompanyCode);

        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);

        const formdata = new FormData();
        formdata.append("pageNumber", page);
        formdata.append("pageSize", pageSize);
        formdata.append("officeCode", effectiveOfficeCode);
        formdata.append("officeLevel", hierarchy);
        formdata.append("showAllApplicationFlag", showAllApplicationsFlag);
        formdata.append("overDueFlag", 0);
        formdata.append("dateFrom", dateFrom);
        formdata.append("dateTo", dateTo);
        formdata.append("applicationProgressId", applicationProgressId);
        formdata.append("objectionStatus", objectionStatus);

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: formdata,
            redirect: "follow"
        };

        const response = await fetch(cfpBaseUrl + `comman/getAllDueDateExtensionApplications`, requestOptions);
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || 'Stats API issue!');
        }

        const result = await response.json();

        if (result.status !== "200" && result.status !== "400") {
            throw new Error(result.message, 'printing error message' || 'Unable to fetch stats!');
        }

        return result;
    }
);

const dueDateExtensionPaginatedNormalSlice = createSlice({
    name: 'dueDateExtensionNormalPaginated',
    initialState: initialState,
    reducers: {
        nextPage(state) {
            state.currentPage += 1;
        },
        previousPage(state) {
            if (state.currentPage > 1) {
                state.currentPage -= 1;
            }
        },
        filterProgressId(state, action) {
            state.applicationProgressId = action.payload
        },
        resetProgressIdFilter(state) {
            state.applicationProgressId = ''
        },
        filterObjectionStatus(state, action) {
            state.objectionStatus = action.payload
        },
        resetObjectionStatusFilter(state) {
            state.applicationProgressId = ''
        },
        filterDateFrom(state, action) {
            state.dateFrom = action.payload
        },
        filterDateTo(state, action) {
            state.dateTo = action.payload
        },
        resetDateFilter(state) {
            state.dateFrom = ''
            state.dateTo = ''
        },
        firstPage(state) {
            state.currentPage = 1;
        },
        lastPage(state, action) {
            state.currentPage = action.payload;
        },
        resetState(state) {
            state.data = []
            state.currentPage = 1
            state.pageSize = 20
            state.dateFrom = ''
            state.dateTo = ''
            state.applicationProgressId = ''
            state.objectionStatus = ''
            state.totalPages = null
            state.totalRecords = null
            state.isLoading = false
            state.error = null
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchPaginatedDueDateExtensionNormal.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchPaginatedDueDateExtensionNormal.fulfilled, (state, action) => {
                state.isLoading = false;
                if (action.payload.data) {
                    state.data = action.payload.data;
                } else {
                    state.data = []
                }
                if (action.payload.totalPages) {
                    state.totalPages = action.payload.totalPages;
                } else {
                    state.totalPages = 1
                }
                state.totalRecords = action.payload.totalRecords;
                state.error = null;
            })
            .addCase(fetchPaginatedDueDateExtensionNormal.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.error.message;
                state.totalPages = null;
                state.totalRecords = null;
            });
    },
});

export const { nextPage, previousPage, firstPage, lastPage, filterProgressId, filterObjectionStatus, filterDateFrom, filterDateTo, resetProgressIdFilter, resetObjectionStatusFilter, resetDateFilter, resetState } = dueDateExtensionPaginatedNormalSlice.actions;

export default dueDateExtensionPaginatedNormalSlice.reducer;
